const pannes = [
  {
    id: "profile-panne-c",
    title: "Profilé Panne C",
    image: "/assets/images/products/Profilé Panne C.webp",
    specImage: null,
    description: "Profilé métallique en forme de C pour charpentes légères",
    longDescription: "Ossature métallique verticale en acier galvanisé, disposant d'une protection contre la corrosion conforme à la norme NF EN 14195. Profilé en forme de « C » destiné à la réalisation de la structure portante des cloisons. Réaction au feu: Euroclasse A1 (non combustible).",
    category: "pannes",
    specifications: [
      "Tableau des spécificités fourni pour les modèles 48/30, 70/30, 90/30, etc.",
      "Réaction au feu: Euroclasse A1 (non combustible)",
      "Protection contre la corrosion conforme à la norme NF EN 14195",
      "Structure portante pour cloisons",
      "Installation professionnelle recommandée"
    ]
  },
  {
    id: "profile-panne-z",
    title: "Profilé Panne Z",
    image: "/assets/images/products/Profilé Panne Z.webp",
    specImage: null,
    description: "Profilé métallique en forme de Z pour toitures et bardages",
    longDescription: "Ossature métallique en forme de Z en acier galvanisé, disposant d'une protection contre la corrosion conforme aux normes en vigueur. Profilé destiné à la réalisation de charpentes légères et structures pour toitures. Excellente stabilité dimensionnelle.",
    category: "pannes",
    specifications: [
      "Dimensions standardisées selon normes industrielles",
      "Acier galvanisé haute qualité",
      "Protection anticorrosion renforcée",
      "Facilité d'assemblage et de fixation",
      "Compatible avec divers systèmes de couverture"
    ]
  }
];

export default pannes;
